<template>
  <methodology></methodology>
</template>

<script>
import Methodology from '@/views/Methodology.vue';

export default {
  components: {
    Methodology
  }
  // setup () {
  // }
};
</script>
